var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg57(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 23.57,
    r: 19.59,
    fill: "#7BC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.31 0H1.96C.96 0 .24.87.24 1.87V23.5H.2a19.6 19.6 0 0 0 19.63 19.62c5.14 0 9.73-1.95 13.36-5.2V1.87c0-1-.88-1.87-1.88-1.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B3E86",
    d: "M8.48 32.73a.7.7 0 0 1-.7.7h-.05a.7.7 0 0 1-.7-.7V4.58c0-.39.3-.7.7-.7h.05c.39 0 .7.31.7.7v28.15zm17.92 2.18a.7.7 0 0 1-.7.7h-.05a.7.7 0 0 1-.7-.7V4.58c0-.39.32-.7.7-.7h.06c.38 0 .7.31.7.7V34.9zm-8.96 1.69a.7.7 0 0 1-.7.7h-.05a.7.7 0 0 1-.7-.7V4.59c0-.39.31-.7.7-.7h.05c.39 0 .7.31.7.7V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7BC8FF",
    d: "M10.42 9.93a1.2 1.2 0 0 1-1.21 1.21H6.3a1.2 1.2 0 0 1-1.21-1.2V7.98c0-.66.54-1.2 1.2-1.2h2.92c.67 0 1.2.54 1.2 1.2v1.94zm8.96 16.72a1.2 1.2 0 0 1-1.21 1.21h-2.9c-.68 0-1.22-.54-1.22-1.21V24.7c0-.67.54-1.21 1.21-1.21h2.91c.67 0 1.21.54 1.21 1.21v1.94zm8.97-13.08c0 .67-.55 1.2-1.22 1.2h-2.9a1.2 1.2 0 0 1-1.21-1.2v-1.94c0-.67.54-1.21 1.2-1.21h2.91c.67 0 1.22.54 1.22 1.2v1.95z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0B3E86",
    d: "M20.5 19.2v23.96c10.66 0 19.55-8.8 19.55-19.63 0-2.2-.41-4.4-1.08-6.33H22.36c-1.07 0-1.86.94-1.86 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.46 23.47a.7.7 0 0 0-.7-.7H25.31a.7.7 0 0 0-.7.7v.06c0 .39.32.7.7.7h11.45a.7.7 0 0 0 .7-.7v-.06zm-6.3 13.08a.7.7 0 0 0-.7-.7h-5.39a.7.7 0 0 0-.7.7v.06c0 .39.32.7.7.7h5.4a.7.7 0 0 0 .69-.7v-.06zm6.3-8.96a.7.7 0 0 0-.7-.7H25.31a.7.7 0 0 0-.7.7v.06c0 .38.32.7.7.7h11.45a.7.7 0 0 0 .7-.7v-.06zm.38 4.87H24.99c-.38 0-.61.39-.61.77v.06c0 .39.23.63.61.63h12.02c.3-.49.57-.97.83-1.46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg57);
export default __webpack_public_path__ + "static/media/5.7.155903789af3aafab7282cdb983b0500.svg";
export { ForwardRef as ReactComponent };